<div mat-dialog-title>
  <h2>Stimulus</h2>
  <eiq-button
    testId="stimulus-picker-close"
    [title]="'Close stimulus picker dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    class="mat-dialog-title__close"
    [disabled]="uploading$()"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="stimulus-picker-dialog__content" [class.multiple]="data.multipleInd">
  @if (entries$().length > 0) {
    @for (file of entries$(); track file.id) {
      <div class="stimulus-picker-dialog__file" [class.failed]="file.state === 'failed' || file.state === 'invalid'">
        @if (file.src && file.file.type === fileType.VideoMp4) {
          <video [attr.data-testid]="'stimulus-picker-video-' + $index" controls>
            <source [src]="file.src" />
          </video>
        } @else if (file.src && file.file.type === fileType.AudioMp3) {
          <audio [attr.data-testid]="'stimulus-picker-audio-' + $index" controls>
            <source [src]="file.src" />
          </audio>
        } @else if (file.src && file.isImage) {
          <img [alt]="file.file.name" [src]="file.src" />
        }

        <div class="stimulus-picker-dialog__file-info">
          <div class="stimulus-picker-dialog__file-info__main">
            <fa-icon [icon]="faFile"></fa-icon>
            <div class="stimulus-picker-dialog__file-info__details">
              <span class="fs__md fw__400 file-name">{{ file.file.name }}</span>
              <span class="fs__sm fw__400 caption file-size">{{ file.size }} MB {{ file.message }}</span>
            </div>
          </div>
          <button
            mat-icon-button
            [attr.data-testid]="'stimulus-picker-remove-' + $index + '-button'"
            [disabled]="uploading$() || file.state === 'uploaded'"
            (click)="onDelete(file.id)"
          >
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </div>
    }
    @if (data.multipleInd) {
      <div class="stimulus-picker-dialog__file add-more">
        <input
          data-testid="stimulus-picker-add-more-input"
          type="file"
          [disabled]="uploading$()"
          #fileDropRef
          [accept]="data.types"
          [multiple]="true"
          (change)="onUploadMore($event)"
        />
        <fa-icon [icon]="faPlus"></fa-icon>
      </div>
    }
  } @else {
    <eiq-file-uploader
      testId="stimulus-picker-upload"
      [acceptedTypes]="data.types"
      [acceptedTypesText]="fileTypeTexts$()"
      [maxSize]="null"
      [multiple]="data.multipleInd"
      (uploaded)="onUpload($event)"
    ></eiq-file-uploader>
  }
</div>
<div mat-dialog-actions>
  @if (maxFilesExceeded$()) {
    <span class="text__md fw__500">Only 1 file is allowed</span>
  }
  @if (summary$()) {
    <p role="status" aria-live="polite" data-testid="stimulus-picker-summary">
      <span>{{ summary$() }}</span>
    </p>
  }
  <button data-testid="stimulus-picker-cancel-button" [disabled]="uploading$()" mat-stroked-button (click)="onCancel()">Close</button>
  <button data-testid="stimulus-picker-save-button" mat-flat-button cdkFocusInitial [color]="'primary'" [disabled]="saveDisabled$()" (click)="onSave()">
    @if (uploading$()) {
      <div class="stimulus-picker-dialog__actions-loading">
        <mat-spinner diameter="20" color="light"></mat-spinner>
        <span>Uploading ({{ batchCompleted$() }} / {{ batchSize$() }})</span>
      </div>
    } @else {
      <span>{{ saveText$() }}</span>
    }
  </button>
</div>
